<template>
  <select
    v-model="currentValue"
    class="custom-select form_select"
    :disabled="readOnly"
    @change="onChange"
  >
    <option
      value=""
      selected
      disabled
    >
      {{ placeholder }}
    </option>
    <option
      v-for="(option, index) in options"
      :key="`name-${index}`"
      :value="option[selectValue]"
    >
      {{ option[selectName] }}
    </option>
  </select>
</template>
<script>
import { normalizeCustomProperty } from '~utils/normalize'
export default {
  name: 'FormSelect',
  props: {
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    name: {
      type: String,
      required: true
    },
    defaultValue: {
      type: [String, Number, Boolean],
      default: ''
    },
    selectName: {
      type: String,
      default: 'name'
    },
    selectValue: {
      type: String,
      default: 'value'
    },
    placeholder: {
      type: String,
      default: '請選擇...'
    },
    readOnly: Boolean
  },
  data () {
    return {
      currentValue: this.defaultValue
    }
  },
  computed: {
    normalizedOptions () {
      return normalizeCustomProperty(this.options, this.selectValue)
    }
  },
  watch: {
    defaultValue (value) {
      this.currentValue = value
    }
  },
  methods: {
    onChange (e) {
      this.$emit('change', this.normalizedOptions[`${e.target.value}`])
    }
  }
}
</script>
